"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAirport = exports.getAirport = exports.addAirport = exports.getAirports = void 0;
const _ = require("lodash");
const getAirports = async (supabase) => {
    const { data: airports, error } = await supabase
        .from("airports")
        .select(`*, country:country_id ( id, name, slug )`);
    if (!error)
        return airports.map((airport) => ({
            id: airport.id,
            name: airport.name,
            code: airport.code,
            country: {
                id: airport.country.id,
                name: airport.country.name,
                slug: airport.country.slug,
            },
        }));
    return error;
};
exports.getAirports = getAirports;
const addAirport = async (supabase, obj) => {
    // add created_by and modified_by to obj
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        obj.modified_by = user?.id;
        obj.created_by = user?.id;
    }
    const { data, error } = await supabase
        .from("airports")
        .insert([obj])
        .select();
    if (!error)
        return data;
    return error;
};
exports.addAirport = addAirport;
const getAirport = async (supabase, id) => {
    const { data: airport, error } = await supabase
        .from("airports")
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return airport;
    return error;
};
exports.getAirport = getAirport;
const updateAirport = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        updateObj.modified_by = user?.id;
    }
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("airports")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateAirport = updateAirport;
